import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-order-or-lot-allocation-components',
  templateUrl: './order-or-lot-allocation-components.component.html',
  styleUrls: ['./order-or-lot-allocation-components.component.css']
})
export class OrderOrLotAllocationComponentsComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.OrderOrLotAllocationComponents.columns;
    this.data = this.report.OrderOrLotAllocationComponents.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.OrderOrLotAllocationComponents.data;
    const gridInstance = this.gridContext.getInstance('OrderOrLotAllocationComponents');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/order-or-lot-allocation-components/order-or-lot-allocation-components.component.ts